import { Injectable } from '@angular/core';
import decode from 'jwt-decode';

const TOKEN_KEY = 'auth-token';
const USER_KEY = 'auth-user';
const EMPRESA_KEY = 'empresa';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  constructor() { }

  public static getToken2(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  signOut(): any {
    window.localStorage.clear();
    window.location.reload();
  }

  public saveToken(token: string): void {
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.setItem(TOKEN_KEY, token);
  }

  public getToken(): string {
    return localStorage.getItem(TOKEN_KEY);
  }

  public saveUser(user): any {
    window.localStorage.removeItem(USER_KEY);
    window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  public getUser(): any {
    return JSON.parse(localStorage.getItem(USER_KEY));
  }

  public getEmpresa(): any {
    let token: any;
    let lookup: string;

    try {
      lookup = localStorage.getItem(TOKEN_KEY);
      if (lookup.indexOf('Bearer') !== -1) {
        lookup = lookup.split('Bearer')[1].trim();
      }
      token = decode(lookup);
    } catch (error){
      token = {empresa: null};
    }
    return token.empresa;
  }

  public getRole(): any {
    let token: any;
    let lookup: string;

    try {
      lookup = localStorage.getItem(TOKEN_KEY);
      if (lookup.indexOf('Bearer') !== -1) {
        lookup = lookup.split('Bearer')[1].trim();
      }
      token = decode(lookup);
    } catch (error){
      token = {role: null};
    }
    return token.role;
  }

  public getZTStatus(): any {
    let token: any;
    let lookup: string;

    try {
      lookup = localStorage.getItem(TOKEN_KEY);
      if (lookup.indexOf('Bearer') !== -1) {
        lookup = lookup.split('Bearer')[1].trim();
      }
      token = decode(lookup);
    } catch (error){
      token = {role: null};
    }
    return token.szstatus;
  }

  public getExtraData(): any {
    let token: any;
    let lookup: string;

    try {
      lookup = localStorage.getItem(TOKEN_KEY);
      if (lookup.indexOf('Bearer') !== -1) {
        lookup = lookup.split('Bearer')[1].trim();
      }
      token = decode(lookup);
    } catch (error){
      token = {role: null};
    }
    return token.extradata;
  }

}
